<template>
  <quote-list-block
    :title="viewmodel.title"
    :empty-result-label="i18n.t('/ProductBlocks/SturingCodes/NoResults')"
  >
    <template v-if="selectedProducts.length > 0" #header>
      <div class="code">{{ i18n.t('/Common/Code') }}</div>
      <div v-if="showInclPrice" class="price price-incl" data-qa="controlCodes-price-incl-header">
        {{ i18n.t('/Common/InclBtw') }}
      </div>
      <div v-if="showExclPrice" class="price price-excl" data-qa="controlCodes-price-excl-header">
        {{ i18n.t('/Common/ExclBtw') }}
      </div>
    </template>

    <template v-if="selectedProducts.length > 0" #body>
      <li v-for="(selectedProduct, index) in selectedProducts" :key="index" class="row">
        <div class="title">{{ selectedProduct.Name }}</div>
        <div class="code">{{ selectedProduct.ShortId }}</div>
        <div v-if="showInclPrice" class="price price-incl" data-qa="price-incl">
          {{ i18n.n(selectedProduct.Price.Incl, 'currency') }}
        </div>
        <div v-if="showExclPrice" class="price price-excl" data-qa="price-excl">
          {{ i18n.n(selectedProduct.Price.Excl, 'currency') }}
        </div>

        <div class="buttons">
          <button
            v-if="!selectedProduct.Forced && isEditable"
            @click="removeFromSelected(selectedProduct)"
          >
            <icon icon="bin" width="20" />
          </button>
          <button v-else disabled="disabled">
            <icon icon="bin" width="20" disabled="disabled" />
          </button>
        </div>
      </li>
    </template>
  </quote-list-block>
</template>

<script>
import QuoteListBlock from '@/components/generic/presentational/molecules/quoteListBlock/QuoteListBlock.vue'
import StoreConnector from '@/helpers/StoreConnector'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    Icon,
    QuoteListBlock,
  },
  props: {
    orderService: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      viewmodel: {},
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      selectedProducts: [],
      isEditable: true,
    }
  },
  computed: {
    ...mapGetters({
      showInclPrice: 'quote/isPriceShowIncl',
      showExclPrice: 'quote/isPriceShowExcl',
    }),
  },
  created() {
    StoreConnector.get('viewmodels/get', (data) => {
      this.viewmodel = data ? data.controlCodes : {}
    })

    StoreConnector.get(`${this.orderService.type}/controlCodes`, (data) => {
      this.selectedProducts = data ? data : []
    })

    StoreConnector.get(`${this.orderService.type}/quoteStatusIsSalesOrder`, (data) => {
      this.isEditable = !data
    })
  },
  methods: {
    removeFromSelected(deselectedProduct) {
      this.orderService.removeControlCode(deselectedProduct)
    },
  },
}
</script>

<style></style>
